import React, { useEffect, useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import "./login.css";
import login_img from "../../assets/images/login_img.png";
import eye from "../../assets/images/eye.png";
import { ReactComponent as Arrow } from "../../assets/images/arrow-left.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import logo from "../../assets/images/logo.png";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { useForm } from "react-hook-form";
import CustomInput from "../common/Input/Input";

const VerifyOtp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(60);
  const [isExpired, setIsExpired] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const { doLogin, currUserData } = useAuthContext();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch("newPassword");
  const confirmPassword = watch("confirmPassword");

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setIsExpired(true);
    }
  }, [countdown]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
      setOtp(newOtp);
    }
  };

  const handleSubmitData = async (data) => {
    if (isExpired) {
      alert("OTP has expired. Please request a new one.");
      return;
    }

    const enteredOtp = otp.join("");
    if (enteredOtp.length === 6) {
      if (data.newPassword !== data.confirmPassword) {
        alert("Passwords do not match.");
        return;
      }

      const payload = {
        email: email,
        otp: enteredOtp,
        newPassword: data.newPassword,
      };

      let res = await api(
        `api/v1/auth/reset-password`,
        payload,
        "postWithoutToken",
        "",
        "Password reset successfully"
      );

      if (res && res.success) {
        navigate("/");
      }
    } else {
      alert("Please enter a valid 6-digit OTP.");
    }
  };

  const handleResendOTP = () => {
    setOtp(["", "", "", "", "", ""]);
    setCountdown(60);
    setIsExpired(false);
    inputRefs.current[0]?.focus();
  };

  return (
    <div className="loginModal">
      <div className="container-fluid">
        <div className="row">
          <div className="login_left">
            <div className="images">
              <img src={login_img} alt="Login Visual" />
            </div>
          </div>
          <div className="login_reight">
            <div className="login-content otp_outer">
              <div>
                <img src={logo} alt="Logo" />
              </div>
              <form className="w-100" onSubmit={handleSubmit(handleSubmitData)}>
                <h6>
                <span onClick={() => navigate(-1)}>
                                      <Arrow />
                                    </span>
                                     Verify OTP
                </h6>

                <div className="otp_section mx-auto">
                  <div className="mb-3">
                    <p className="mb-3">
                      Please enter the OTP sent to {email}
                    </p>
                    <div className="d-flex justify-content-between">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          className="form-control text-center otp-input"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          ref={(el) => (inputRefs.current[index] = el)}
                          // disabled={isExpired}
                        />
                      ))}
                    </div>
                  </div>

                  <p className="text-danger text-center">
                    {isExpired ? (
                      <>
                        Didn't receive code?{' '}
                        <span
                          className="btn-link ps-1 text-primary"
                          onClick={handleResendOTP}
                          style={{ cursor: "pointer" }}
                        >
                          Resend OTP
                        </span>
                      </>
                    ) : (
                      `OTP expires in ${countdown}s`
                    )}
                  </p>

                  <div className="Password">
                    <CustomInput
                      register={register}
                      label="New Password"
                      name="newPassword"
                      placeholder="e.g., ********"
                      type={showPassword ? "text" : "password"}
                      errors={errors.newPassword}
                      validation={{ required: "New Password is required" }}
                    />
                    <span className="icon">
                      <img
                        onClick={() => setShowPassword(!showPassword)}
                        src={eye}
                        alt="Toggle Visibility"
                      />
                    </span>
                  </div>

                  <div className="Password">
                    <CustomInput
                      register={register}
                      label="Confirm New Password"
                      name="confirmPassword"
                      placeholder="e.g., ********"
                      type={showPassword ? "text" : "password"}
                      errors={errors.confirmPassword}
                      validation={{ required: "Please confirm your password" }}
                    />
                    <span className="icon">
                      <img
                        onClick={() => setShowPassword(!showPassword)}
                        src={eye}
                        alt="Toggle Visibility"
                      />
                    </span>
                  </div>

                  <button
                    className="mx-auto d-block btn_primary w-100 mb-5 mt-5"
                    type="submit"
                    // disabled={isExpired}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;